import classNames from 'classnames';

export interface MinimalTableSkeletonProps {
  rows?: number;
  large?: boolean;
}

export const MinimalTableSkeleton = ({
  rows = 3,
  large,
}: MinimalTableSkeletonProps) => {
  return (
    <div className="flex flex-col">
      {Array.from(Array(rows)).map((_, index) => (
        <div
          key={index}
          className={classNames(
            'flex items-center animate-pulse gap-4',
            large ? 'py-4' : 'py-3'
          )}
        >
          <div className="flex-auto flex items-center gap-2">
            <div className="bg-ds-natural-150 rounded-full w-5 h-5" />
            <div className="w-1/3 bg-ds-natural-150 w-full rounded-sm h-2" />
          </div>
          <div className="w-1/3 flex justify-center">
            <div className="w-1/3 bg-ds-natural-150 w-full rounded-sm h-2" />
          </div>
        </div>
      ))}
      {large && <div className="h-24" />}
    </div>
  );
};
